var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  Write to the P2WDB

*/
// Public npm libraries
var axios = require('axios');

var RetryQueue = require('@chris.troutner/retry-queue-commonjs'); // Constants that can be customized.


var P2WDB_SERVER = 'https://p2wdb.fullstack.cash'; // const P2WDB_SERVER = 'http://localhost:5010'

var PSF_TOKEN_ID = '38e97c5d7d3585a2cbf3f9580c82ca33985f9cb0845d4dcce220cb709f9538b0'; // const PROOF_OF_BURN_QTY = 0.01

var SAT_THRESHOLD = 5000;

var Write = /*#__PURE__*/function () {
  "use strict";

  function Write() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Write);

    // Dependency Injection
    this.bchWallet = localConfig.bchWallet;

    if (!this.bchWallet) {
      throw new Error('Must pass instance of minimal-slp-wallet as bchWallet when instantiating P2WDB Write library.');
    } // Encapsulate dependencies


    this.axios = axios;
    this.serverURL = localConfig.serverURL || P2WDB_SERVER;
    this.retryQueue = new RetryQueue({
      attempts: 3,
      retryPeriod: 1000
    }); // Default cost in PSF tokens for a write. This value will be overwritten
    // by data retrieved from the P2WDB server.

    this.writeCost = 0.133;
    this.writeTokenId = PSF_TOKEN_ID; // Bind 'this' object to subfunctions.

    this.checkForSufficientFunds = this.checkForSufficientFunds.bind(this);
    this.burnPsf = this.burnPsf.bind(this);
    this.postEntryForPsf = this.postEntryForPsf.bind(this);
    this.postEntryForBch = this.postEntryForBch.bind(this);
    this.postEntry = this.postEntry.bind(this);
    this.getWriteCostPsf = this.getWriteCostPsf.bind(this);
    this.getWriteCostBch = this.getWriteCostBch.bind(this);
  } // Given a data object and an app ID, this method will write the
  // data to the P2WDB. It will return an object.


  _createClass(Write, [{
    key: "postEntry",
    value: function () {
      var _postEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var appId,
            _yield$this$retryQueu,
            hasEnoughPsf,
            hasEnoughBch,
            bchAddr,
            now,
            message,
            signature,
            burnTxid,
            dataObj,
            bodyData,
            result,
            receivers,
            txid,
            _bodyData,
            _result,
            objOut,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                appId = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'test';
                _context.prev = 1;

                if (data) {
                  _context.next = 4;
                  break;
                }

                throw new Error('data required to write to p2wdb');

              case 4:
                _context.next = 6;
                return this.retryQueue.addToQueue(this.checkForSufficientFunds, {});

              case 6:
                _yield$this$retryQueu = _context.sent;
                hasEnoughPsf = _yield$this$retryQueu.hasEnoughPsf;
                hasEnoughBch = _yield$this$retryQueu.hasEnoughBch;
                bchAddr = _yield$this$retryQueu.bchAddr;
                console.log("hasEnoughPsf: ".concat(hasEnoughPsf, ", hasEnoughBch: ").concat(hasEnoughBch, ", bchAddr: ").concat(bchAddr)); // Wallet controls PSF tokens. This is the preferred payment method.

                if (!hasEnoughPsf) {
                  _context.next = 25;
                  break;
                }

                // Generate a signature, to verify the address providing proof-of-burn is
                // the same one that is submitting the data.
                now = new Date();
                message = now.toISOString();
                signature = this.generateSignature(message); // console.log(`message: ${message}`)
                // console.log(`signature: ${signature}`)
                // Burn enough PSF tokens to provide proof-of-burn.

                _context.next = 17;
                return this.retryQueue.addToQueue(this.burnPsf, {});

              case 17:
                burnTxid = _context.sent;
                console.log("proof-of-burn TXID: ".concat(burnTxid)); // The data object that will be recorded to the P2WDB.

                dataObj = {
                  appId: appId,
                  data: data,
                  timestamp: now.toISOString(),
                  localTimeStamp: now.toLocaleString()
                }; // The data used to form the body of the POST REST API call.

                bodyData = {
                  txid: burnTxid,
                  message: message,
                  signature: signature,
                  data: JSON.stringify(dataObj)
                }; // const result = await this.axios.post(
                // `${this.serverURL}/entry/write`,
                // bodyData
                // )

                _context.next = 23;
                return this.retryQueue.addToQueue(this.postEntryForPsf, bodyData);

              case 23:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 25:
                if (!hasEnoughBch) {
                  _context.next = 38;
                  break;
                }

                // Send required BCH to the payment address.
                receivers = [{
                  address: bchAddr,
                  amountSat: this.bchWallet.bchjs.BitcoinCash.toSatoshi(hasEnoughBch)
                }]; // console.log(`receivers: ${JSON.stringify(receivers, null, 2)}`)

                _context.next = 29;
                return this.retryQueue.addToQueue(this.bchWallet.send, receivers);

              case 29:
                txid = _context.sent;
                _context.next = 32;
                return this.bchWallet.bchjs.Util.sleep(3000);

              case 32:
                // Submit the data to be written to the P2WDB.
                _bodyData = {
                  address: bchAddr,
                  data: data,
                  appId: appId
                }; // const result = await this.axios.post(`${this.serverURL}/entry/write/bch`,
                //   bodyData)

                _context.next = 35;
                return this.retryQueue.addToQueue(this.postEntryForBch, _bodyData);

              case 35:
                _result = _context.sent;
                // console.log('result.data: ', result.data)
                // Create a data object that matches the same format as the one generated
                // when using PSF to pay the write fee.
                objOut = {
                  success: true,
                  hash: _result.data.hash.hash,
                  paymentTxid: txid
                };
                return _context.abrupt("return", objOut);

              case 38:
                _context.next = 44;
                break;

              case 40:
                _context.prev = 40;
                _context.t0 = _context["catch"](1);
                console.error('Error in p2wdb/write.js/postEntry(): ', _context.t0);
                throw _context.t0;

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 40]]);
      }));

      function postEntry(_x) {
        return _postEntry.apply(this, arguments);
      }

      return postEntry;
    }() // This function makes a REST API call to the P2WDB to post a new entry in
    // exchange for burning PSF. This function wraps axios in a promise-based
    // function with an object input, so that it can be called with retry-queue.

  }, {
    key: "postEntryForPsf",
    value: function () {
      var _postEntryForPsf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(bodyData) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axios.post("".concat(this.serverURL, "/entry/write"), bodyData);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function postEntryForPsf(_x2) {
        return _postEntryForPsf.apply(this, arguments);
      }

      return postEntryForPsf;
    }() // This function makes a REST API call to the P2WDB to post a new entry in
    // exchange for BCH. This function wraps axios in a promise-based function
    // with an objecg input, so that it can be called with retry-queue.

  }, {
    key: "postEntryForBch",
    value: function () {
      var _postEntryForBch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(bodyData) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.axios.post("".concat(this.serverURL, "/entry/write/bch"), bodyData);

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postEntryForBch(_x3) {
        return _postEntryForBch.apply(this, arguments);
      }

      return postEntryForBch;
    }() // This method checks the private key to ensure it has enough BCH or PSF
    // tokens to fund a write to the P2WDB.
    // It should be called before attempting to write to the P2WDB.
    // It will return an object with the following properties:
    // {
    //   hasEnoughPsf: false if wallet does not have enough PSF. Otherwise is a
    //                 Number with the number of PSF tokens needed to
    //                 write to the P2WDB.
    //   hasEnoughBch: false if wallet does not have enough BCH. Otherwise is a
    //                 Number with the number of sats needed to write to P2WDB.
    //   bchAddr:      The address to send BCH in order to pay for a write.
    // }

  }, {
    key: "checkForSufficientFunds",
    value: function () {
      var _checkForSufficientFunds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var balance, writeCost, tokens, hasEnoughBch, hasEnoughPsf, psfTokens, bchAddr, _yield$this$getWriteC, bchCost, address;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.bchWallet.walletInfoPromise;

              case 3:
                _context4.next = 5;
                return this.bchWallet.initialize();

              case 5:
                _context4.next = 7;
                return this.bchWallet.getBalance();

              case 7:
                balance = _context4.sent;

                if (!(balance < SAT_THRESHOLD)) {
                  _context4.next = 10;
                  break;
                }

                throw new Error('Wallet has less than 5,000 sats, not enough funds to pay for a write.');

              case 10:
                _context4.next = 12;
                return this.getWriteCostPsf();

              case 12:
                writeCost = _context4.sent;
                console.log("P2WDB Write cost: ".concat(writeCost, " PSF tokens")); // Get a list of SLP tokens held by the wallet.

                _context4.next = 16;
                return this.bchWallet.listTokens();

              case 16:
                tokens = _context4.sent;
                console.log("tokens: ".concat(JSON.stringify(tokens, null, 2))); // Initialize state

                hasEnoughBch = false;
                hasEnoughPsf = false;
                console.log("writeTokenId: ".concat(this.writeTokenId)); // Verify if there is enough PSF tokens to pay for the write.

                psfTokens = tokens.filter(function (x) {
                  return x.tokenId === _this.writeTokenId;
                });
                console.log("psfTokens: ".concat(JSON.stringify(psfTokens, null, 2)));

                if (!psfTokens.length) {
                  // Wallet has PSF no tokens
                  hasEnoughPsf = false;
                } else if (psfTokens[0].qty < writeCost) {
                  // Wallet has PSF tokens, but not enough.
                  hasEnoughPsf = false;
                } else {
                  // Wallet has an adaquate amount of PSF tokens to pay for a write.
                  hasEnoughPsf = writeCost;
                }

                bchAddr = ''; // If the wallet doesn't have enough PSF to pay for a write, check to see if
                // it has enough BCH, and if the P2WDB supports paying in BCH.

                if (hasEnoughPsf) {
                  _context4.next = 37;
                  break;
                }

                _context4.prev = 26;
                _context4.next = 29;
                return this.getWriteCostBch();

              case 29:
                _yield$this$getWriteC = _context4.sent;
                bchCost = _yield$this$getWriteC.bchCost;
                address = _yield$this$getWriteC.address;

                if (bchCost < balance) {
                  hasEnoughBch = bchCost;
                  bchAddr = address;
                }

                _context4.next = 37;
                break;

              case 35:
                _context4.prev = 35;
                _context4.t0 = _context4["catch"](26);

              case 37:
                if (!(!hasEnoughPsf && !hasEnoughBch)) {
                  _context4.next = 39;
                  break;
                }

                throw new Error('Provided wallet does not have enough PSF tokens or BCH to pay for a write.');

              case 39:
                return _context4.abrupt("return", {
                  hasEnoughPsf: hasEnoughPsf,
                  hasEnoughBch: hasEnoughBch,
                  bchAddr: bchAddr
                });

              case 42:
                _context4.prev = 42;
                _context4.t1 = _context4["catch"](0);
                console.error('Error in p2wdb/lib/write.js/checkForSufficientFunds(): ', _context4.t1);
                throw _context4.t1;

              case 46:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 42], [26, 35]]);
      }));

      function checkForSufficientFunds() {
        return _checkForSufficientFunds.apply(this, arguments);
      }

      return checkForSufficientFunds;
    }() // This function will burn enough PSF to generate a proof-of-burn TXID.
    // It will return the TXID as a string.
    // It's assumed checkForSufficientFunds() is called before this function.

  }, {
    key: "burnPsf",
    value: function () {
      var _burnPsf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.bchWallet.initialize();

              case 2:
                _context5.next = 4;
                return this.bchWallet.burnTokens(this.writeCost, this.writeTokenId);

              case 4:
                result = _context5.sent;
                return _context5.abrupt("return", result);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function burnPsf() {
        return _burnPsf.apply(this, arguments);
      }

      return burnPsf;
    }() // Generate a cryptographic signature, required to write to the P2WDB.

  }, {
    key: "generateSignature",
    value: function generateSignature(message) {
      // TODO: Add input validation for message.
      var privKey = this.bchWallet.walletInfo.privateKey; // console.log('privKey: ', privKey)
      // console.log('flags.data: ', flags.data)

      var signature = this.bchWallet.bchjs.BitcoinCash.signMessageWithPrivKey(privKey, message);
      return signature;
    } // Get the cost of a write from the P2WDB, in terms of PSF tokens.

  }, {
    key: "getWriteCostPsf",
    value: function () {
      var _getWriteCostPsf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var result, cost, tokenId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.axios.get("".concat(this.serverURL, "/entry/cost/psf"));

              case 2:
                result = _context6.sent;
                cost = result.data.psfCost;
                tokenId = result.data.tokenId;
                console.log("cost: ".concat(cost, ", tokenId: ").concat(tokenId)); // Update the state.

                this.writeCost = cost;
                this.writeTokenId = tokenId;
                return _context6.abrupt("return", cost);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getWriteCostPsf() {
        return _getWriteCostPsf.apply(this, arguments);
      }

      return getWriteCostPsf;
    }() // Get the cost of a write from the P2WDB, in terms of BCH.
    // If the P2WDB instance does not support this feature, it throws an error.

  }, {
    key: "getWriteCostBch",
    value: function () {
      var _getWriteCostBch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var result, bchCost, address;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.axios.get("".concat(this.serverURL, "/entry/cost/bch"));

              case 2:
                result = _context7.sent;
                // console.log(`result: ${JSON.stringify(result.data, null, 2)}`)
                bchCost = result.data.bchCost;
                address = result.data.address;
                return _context7.abrupt("return", {
                  bchCost: bchCost,
                  address: address
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getWriteCostBch() {
        return _getWriteCostBch.apply(this, arguments);
      }

      return getWriteCostBch;
    }()
  }]);

  return Write;
}();

module.exports = Write;